module.exports = __webpack_public_path__ + "media/images/logo-uk-e5bdf1e218fed1803a46afe23371a058.svg";